import React, { Component } from "react";
import PropTypes from "prop-types";
import {remove} from 'lodash'
import { connect } from "react-redux";
import { compose } from "redux";
import { getCompany, createCompany, updateCompany, getCompanyLevels, createCompanyReportingEmail } from "store/state/companies";
import Modal from "components/Modal";
import { FormControl, InputLabel, Input, Button, DialogContent, DialogActions, Divider, FormHelperText, FormControlLabel, Checkbox } from "@material-ui/core";
import styled from "styled-components";
import ConnectedCompanyCheckboxes from "./CompanyCheckboxes";
import CompanyIdentifiers from "./CompanyIdentifiers";
import TypeAheadDropdown from "components/Global/Fields/TypeAheadDropdown";


const BigDivider = styled(Divider)`
  && {
    margin-top: 24px;
    margin-bottom: 8px;
    background-color: #ccc;
  }
`;

const NameControl = styled(FormControl)`
  && {
    width: 300px;
  }
`;

const StyledTypeAheadDropdown = styled(TypeAheadDropdown)`
  color: black;
  border: 1px solid;
  width: -webkit-fill-available;
  font-size: 14px;
  height: 40px;
  display: inline-block;
`;

const TestingCompanyCheckboxLabel = styled(FormControlLabel)`
  && {
    width: 238px;
    height: 40px;
    padding-top: 23px;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  align-content: space-between;
`;

const CompanyIdentifierWrapper = styled.div`
    width: 100%;
    height: 319px;
    margin: 18px;
    background: #FFFFFF;
    border: 1px solid #005AA9;
    box-sizing: border-box;
    padding-left: 5px;
`;


export const CompanyFormContext = React.createContext({
  shouldShowError: false
});
export class CompanyForm extends Component {
  state = {
    company: null,
    error: {
      name: false,
      companyTypes: false
    },
    originalCompanyReportingEmail: null,
  };

  componentDidMount() {
    const { companyId } = this.props;
    this.reinitialize(companyId);
    this.props.getCompanyLevels();
  }

  componentDidUpdate(prevProps, prevState) {
    const { companyId } = this.props;
    const prevCompanyId = prevProps.companyId;
    if (companyId !== prevCompanyId) {
      this.reinitialize(companyId);
    }
    this.setFormInitialState(this.props, prevProps, prevState);
  }

  reinitialize = companyId => {
    if (companyId) this.props.getCompany({ id: companyId });
    else {
      this.setState({
        company: this.createCompany(),
        originalCompanyReportingEmail: null,
      });
    }
  };

  setFormInitialState = (props, prevProps, prevState) => {
    const { companyToEdit } = props;
    if (this.shouldEditCompany(props, prevProps)) {
      const companyCopy = { ...companyToEdit };
      companyCopy.companyTypes = companyCopy.companyTypes.map(x => x.id);
      this.setState({
        company: companyCopy,
        originalCompanyReportingEmail: companyCopy.companyReportingEmail
      });
    } else if (this.shouldCreateCompany(props, prevState)) {
      this.setState({
        company: this.createCompany(),
        originalCompanyReportingEmail: null,
      });
    }
  };

  shouldEditCompany = (props, prevProps) => {
    const { companyId, companyToEdit } = props;
    return companyId && companyToEdit !== prevProps.companyToEdit;
  };

  shouldCreateCompany = (props, prevState) => {
    const { companyId } = props;
    return !companyId && !prevState.company;
  };

  createCompany = () => ({
    name: "",
    companyTypes: []
  });

  handleClose = () => {
    this.setState({
      company: null
    });
    this.props.closeModal();
  };

  handleChange = ({ target: { name, value } }) => {
    const { company } = this.state;
    const newCompany = {
      ...company,
      [name]: value
    };
    this.setState({
      company: newCompany
    });
  };

  handleCheck = ({ target: { name, checked } }) => {
    const { company } = this.state;
    const newCompany = {
      ...company,
      [name]: checked
    };

    this.setState({ company: newCompany });
  };

  handleLevelChange = newlevelid => {
    const { company } = this.state;
    const newCompany = {
      ...company
    };
    newCompany.companyLevelId = newlevelid;
    this.setState({ company: newCompany });
  };

  handleCompanyReportingEmailChange = newCompanyReportingEmail => {
    const { company } = this.state;
    const newCompany = {
      ...company
    };
    newCompany.companyReportingEmail = newCompanyReportingEmail;
    this.setState({ company: newCompany });
  };

  handleParentChange = event => {
    let c = this.state.company;
    c.parentId = event.value;
    this.setState({ company: c });
  };

  setCompanyTypes = companyTypes => {
    const newCompany = { ...this.state.company };
    newCompany.companyTypes = companyTypes.filter(x => x.checked).map(x => x.id);
    this.setState({
      company: newCompany,
      error: this.validate(newCompany)
    });
  };

  handleEdit = () => {
    if (!this.hasErrors()) {
      if (this.state.company.companyReportingEmail !== this.state.originalCompanyReportingEmail) {
        this.props.createCompanyReportingEmail({ payload: this.state.company.companyReportingEmail });
      }

      this.props.updateCompany({
        companyId: this.props.companyId,
        payload: this.state.company
      });
      this.handleClose();
    }
  };

  handleCreate = () => {
    if (!this.hasErrors()) {
      if (this.state.company.companyReportingEmail){
        this.props.createCompanyReportingEmail({ payload: this.state.company.companyReportingEmail });
      }

      this.props.createCompany({ payload: this.state.company });
      this.handleClose();
    }
  };

  hasErrors = () => {
    const { error } = this.state;
    return error.name || error.companyTypes;
  };

  handleValidate = () => {
    const { company } = this.state;
    const companyError = this.validate(company);
    this.setState({
      error: companyError
    });
  };

  validate = company => ({
    name: this.validateName(company),
    companyTypes: this.validateCompanyTypes(company),
    // companyReportingEmail: this.validateCompanyReportingEmail(company)
  });

  validateName = company => !company.name; // sorry for ternary. want to return boolean type instead of falsy or truthy

  validateCompanyTypes = company => company.companyTypes.length === 0;

  validateCompanyReportingEmail = company => {
    const re = /\S+@\S+\.\S+/;
    return !re.test(String(company.companyReportingEmail).toLowerCase());
  };

  renderNameError = () => {
    if (this.state.error.name) {
      return <FormHelperText>Name is Required</FormHelperText>;
    }
    return null;
  };

  renderCompanyReportingEmailError = () => {
    if (this.state.error.companyReportingEmail) {
      return <FormHelperText>Reporting Email is invalid</FormHelperText>;
    }
    return null;
  };

  getSubscriptionLevels = () => {
    return this.props.companyLevels;
  };

  getPotentialParents = () => {
    let out = [];
    out.push({ name: "None", label: "None", value: null });
    this.props.allCompanies.forEach(company => {
      out.push({ name: company.name, label: company.name, value: company.id });
    });
    return out;
  };

  addCompanyIdentifiers = (identifier) => {
    const {company} = this.state;
    if(!company.companyIdentifiers)
      company.companyIdentifiers = [];

      const ci = {companyId: company.id, value: identifier};
    company.companyIdentifiers.push(ci);

    this.setState({company});
  }

  removeCompanyIdentifiers = (identifier) => {
    const { company } = this.state;

    remove(company.companyIdentifiers, {
      value: identifier.value
    });
    this.setState({ company });
  }

  render() {
    const { companyId } = this.props;

    const { company } = this.state;
    if (!company) {
      // need to wait for form to initialize
      return null;
    }
    const handleSave = companyId ? this.handleEdit : this.handleCreate;
    const subscriptionLevels = this.getSubscriptionLevels();

    return (
      <React.Fragment>
        <CompanyFormContext.Provider value={this.state.error.companyTypes}>
          <Modal hideModal={this.handleClose} open modalTitle={companyId ? "Edit Company" : "New Company"} className="newUser">
            <DialogContent style={{ maxWidth: "730px", overflowY: "visible" }}>
              <form>
                <FormWrapper>
                  <div>
                    <div>
                      <NameControl error={this.state.error.name} margin="normal">
                        <InputLabel htmlFor="name">Company Name *</InputLabel>
                        <Input type="text" name="name" autoFocus onChange={this.handleChange} onBlur={event => this.handleValidate(event)} value={company.name} />
                        {this.renderNameError()}
                      </NameControl>
                    </div>
                      <InputLabel htmlFor="subscription level">Subscription Level</InputLabel>
                      <StyledTypeAheadDropdown
                        name="subscription level"
                        options={subscriptionLevels}
                        usingFormik={false}
                        shouldShow={true}
                        value={company.companyLevelId}
                        handleChange={event => this.handleLevelChange(event)}
                      />
                      <InputLabel htmlFor="Parent Company">Parent Company</InputLabel>
                      <StyledTypeAheadDropdown
                        name="Parent Company"
                        placeholder={"None"}
                        options={this.getPotentialParents()}
                        usingFormik={false}
                        shouldShow={true}
                        value={this.state.company.parentId}
                        handleChange={event => this.handleParentChange(event)}
                      />
                    <div>
                      <NameControl error={this.state.error.companyReportingEmail} margin="dense">
                        <InputLabel htmlFor="companyReportingEmail">Reporting Email</InputLabel>
                        <Input
                          type="text"
                          name="companyReportingEmail"
                          onChange={this.handleChange}
                          onBlur={event => this.handleValidate(event)}
                          value={company.companyReportingEmail}
                        />
                        {this.renderCompanyReportingEmailError()}
                      </NameControl>
                    </div>
                    <div>
                      <TestingCompanyCheckboxLabel
                        key={'isActiveAccount'}
                        control={
                          <Checkbox
                            name={"isActiveAccount"}
                            checked={company.isActiveAccount}
                            onChange={this.handleCheck}
                            value={company.isActiveAccount} />
                        }
                        label={"Active"}
                      />

                      <TestingCompanyCheckboxLabel
                        key={'isTestAccount'}
                        control={
                          <Checkbox
                            name={"isTestAccount"}
                            checked={company.isTestAccount}
                            onChange={this.handleCheck}
                            value={company.isTestAccount} />
                        }
                        label={"Testing"}
                      />
                    </div>
                  </div>
                  
                  <CompanyIdentifierWrapper>
                    <CompanyIdentifiers 
                    company={company}
                    addCompanyIdentifiers={this.addCompanyIdentifiers}
                    removeCompanyIdentifiers={this.removeCompanyIdentifiers}
                    />
                  </CompanyIdentifierWrapper>
                </FormWrapper>
                <BigDivider />
                <ConnectedCompanyCheckboxes company={company} setCompanyTypes={this.setCompanyTypes} />
              </form>
            </DialogContent>

            <DialogActions>
              <Button onClick={this.handleClose}>Cancel</Button>
              <Button size="medium" onClick={handleSave} type="submit">
                Save
              </Button>
            </DialogActions>
          </Modal>
        </CompanyFormContext.Provider>
      </React.Fragment>
    );
  }
}
CompanyForm.propTypes = {
  companyId: PropTypes.number,
  closeModal: PropTypes.func.isRequired
};

const mapStateToProps = ({ authentication, companies }) => ({
  authentication,
  companyLevels: companies.companyLevels,
  companyToEdit: companies.company,
  companyError: companies.companyError,
  allCompanies: companies.allCompanies ? companies.allCompanies.companies : []
});

export default compose(
  connect(
    mapStateToProps,
    { getCompany, createCompany, updateCompany, getCompanyLevels, createCompanyReportingEmail }
  )
)(CompanyForm);
